









































































import { Component, Vue } from "vue-property-decorator";
import {
  FiltroEnviosAutomaticos,
  EnviosAutomaticosService,
  EnvioAutomatico,
} from "@/services/envios-automaticos.service";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import { ServerPageOptions } from "@/shared/utils/datatable";
import Manter from "./Manter.vue";

@Component({
  components: { DataTable, Tooltip, Manter },
})
export default class EnviosAutomaticos extends Vue {
  filtro: FiltroEnviosAutomaticos = {
    apenasAtivos: false,
    txtPesquisa: "",
    offset: 0,
    limit: 100,
    order: "",
  }
  selectRow = true;

  promise: Promise<EnvioAutomatico[]> | null = null;

  headers = [
    { value: "nome", text: "Nome" },
    { value: "descricao", text: "Descrição" },
    { value: "template", text: "Template" },
    { value: "ativo", text: "Ativo" },
    { value: "hrExecucao", text: "Hora" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  mounted() {
    this.filtro.txtPesquisa = "";
  }

  fetchEnviosAutomaticos(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }
    this.promise = EnviosAutomaticosService.listarEnviosAutomaticos(this.filtro);
  }

  async editarEnvioAutomatico(envioAutomatico: EnvioAutomatico) {
    const modal = this.$refs.manter as Manter;
    await modal.editarEnvioAutomatico(envioAutomatico.idEnvioAutomatico!);
    this.fetchEnviosAutomaticos();
  }

  async ativarEnvioAutomatico(envioAutomatico: EnvioAutomatico) {
    await EnviosAutomaticosService.ativarEnvioAutomatico(envioAutomatico);
  }
}
